
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },

  mounted() {
    this.$nextTick(() => {
      if (this.$matchMedia('sm')) {
        this.initAnim()
      }
    })
  },
  methods: {
    initAnim() {
      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs.container,
          start: 'top center+=8%',
          end: '100%',
          scrub: true,
          // pin: true,
          // markers: true,
        },
      })

      tl.fromTo(
        this.$refs.container,
        {
          clipPath: 'circle(180px)',
        },
        {
          clipPath: `circle(${window.innerWidth}px)`,
          duration: 2,
        }
      )
    },
  },
}
